module.exports = __webpack_public_path__ + "static/media/ricardo-perez-parking-selected.94b23e1a.svg";